import { useContext } from 'react';
import { formatDate } from '@gtintel/platform-utils';
import { ProjectContext } from '../../context';
import styles from './styles.module.scss';
const ProjectDetailsCard = () => {
  const ctx = useContext(ProjectContext);
  const partnerPriceLabel = 'Your fee';
  const priceLabelPrepend = ' (Excluding VAT or other applicable taxes)';
  const id = ctx.projectId();
  const partner_price = ctx.partnerPrice();
  const currency = ctx.currency();
  const qaRequired = ctx.qaRequired();
  const rawRequestedCompletionDate = qaRequired || ctx.npCompletionDate() ? ctx.npCompletionDate() : ctx.requestedCompletionDate();
  return <section className={styles.section}>
      <div className={styles.details}>
        <p>
          <span>Project ID: </span>
          {'#'}
          {id}
        </p>

        <p>
          <span>Project Type: </span>
          {ctx.projectType()}
        </p>

        {!!rawRequestedCompletionDate && <p>
            <span>Due Date: </span> {formatDate(rawRequestedCompletionDate)}
          </p>}

        <p>
          <span>{partnerPriceLabel}: </span>
          {`${currency}${partner_price}`}
          {priceLabelPrepend}
        </p>

        {ctx.data().description && <p>
            <span className={styles.h5}>Description: </span>
            {ctx.data().description}
          </p>}
      </div>
    </section>;
};
export default ProjectDetailsCard;